// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles_buttonWrapper__VN7aH","description":"styles_description__2pK8l","editButton":"styles_editButton__19g_d","editIcon":"styles_editIcon__1lOpO"};